@if (options(); as options) {
  <mbp-modal id="confirmation-modal" [modalTitle]="options.title ?? ('general.confirmation' | translate)"
    (close)="onCancel()">
    <div slot="modal-content" class="confirmation-content">
      <p data-testid="confirmation-subtitle" class="confirmation-subtitle">
        {{ options.subtitle ?? ('general.confirmationSubtitle' | translate) }}</p>
      <div data-testid="confirmation-message" class="confirmation-message">
        <p class="message-main">{{ options.message }}</p>
        @if (options.message2) {
          <p class="message-secondary">{{ options.message2 }}</p>
        }
      </div>
    </div>

    <ng-container slot="modal-footer">
      <mbp-button data-testid="confirmation-cancel-btn" type="secondary"
        [text]="options.cancelText ?? ('general.cancel' | translate)" (buttonClick)="onCancel()"></mbp-button>
      @if (options.altText) {
        <mbp-button data-testid="confirmation-alt-btn" type="secondary" [text]="options.altText"
          (buttonClick)="onAlt()"></mbp-button>
      }
      <mbp-button data-testid="confirmation-confirm-btn" data-modal-primary type="primary"
        [text]="options.okText ?? ('general.confirm' | translate)" (buttonClick)="onConfirm()"></mbp-button>
    </ng-container>
  </mbp-modal>
}
